
import { css } from '@emotion/react';
import React from 'react';
import { LazyImage, Image } from '..';

export interface ImageProp {
    src: string;
    alt: string;
    width?: string | number;
    height?: string | number;
}

interface Props {
    image: ImageProp;
    isLazy: boolean;
    defaultImg?: React.ComponentType<any>;
}

const ImageStyle = (width?: string | number, height?: string | number) => css`
    height: 100%;
    position: absolute;
    top: 0;
    
    ${height && `height: ${height};`}
    ${width && `width: ${width};`}
`;

const ListingTileThumbnail = ({ image, isLazy = true, defaultImg }: Props) => {
    const { alt, src, width, height } = image || {};

    if (!src && defaultImg) {
        const NoImg = defaultImg
        return <NoImg />;
    }

    return isLazy ? (
        <LazyImage css={ImageStyle(width, height)} src={src} alt={alt} className="listing-tile-thumbnail-image" />
    ) : (
        <Image css={ImageStyle(width, height)} src={src} alt={alt} className="listing-tile-thumbnail-image" />
    );
};

export default ListingTileThumbnail;
